import PropTypes from 'prop-types';
import { ArrowRight } from 'lucide-react';
import styles from './AnimatedLink.module.css';

/**
 * AnimatedLink - Link component with hover animation
 * Features arrow animation or underline effect
 */
export function AnimatedLink({
  children,
  href = '#',
  to,
  arrow = false,
  underline = true,
  external = false,
  color = 'cyan',
  size = 'base',
  className = '',
  onClick,
  ...props
}) {
  const classNames = [
    styles.link,
    styles[color],
    styles[size],
    arrow && styles.withArrow,
    underline && styles.withUnderline,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const linkProps = {
    className: classNames,
    onClick,
    ...props,
  };

  if (external) {
    linkProps.href = href;
    linkProps.target = '_blank';
    linkProps.rel = 'noopener noreferrer';
  } else if (to) {
    linkProps.href = to;
  } else {
    linkProps.href = href;
  }

  return (
    <a {...linkProps}>
      <span className={styles.text}>{children}</span>
      {arrow && (
        <span className={styles.arrow}>
          <ArrowRight size={16} />
        </span>
      )}
    </a>
  );
}

AnimatedLink.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string,
  to: PropTypes.string,
  arrow: PropTypes.bool,
  underline: PropTypes.bool,
  external: PropTypes.bool,
  color: PropTypes.oneOf(['cyan', 'lime', 'white']),
  size: PropTypes.oneOf(['sm', 'base', 'lg']),
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default AnimatedLink;
